import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Mawalog from "./components/mawalog";
import Pricing from "./components/Pricing";
import About from "./components/About";
import Sayhello from "./components/Sayhello";
import Partner from "./components/Partner";
import Terms from "./components/Terms";
import Gate from "./components/Gate";
import Industries from "./components/Industries";
import Features from "./components/Features";
import Faq from "./components/Faq";
import MeetQ from "./components/MeetQ";
import FeaturesQ from "./components/FeaturesQ";
import IndustriesQ from "./components/IndustriesQ";
import MeetFaq from "./components/MeetFaq";
import SAGate from "./components/SAGate";
import Price from "./components/Price";
import PriceQ from "./components/PriceQ";
import ScrollToTop from "./components/ScrollToTop";
import ExploreProduct from "./components/ExploreProduct"; // Importing
import Coming from "./components/Coming"; // Importing Coming
import Policy from "./components/Policy";
import Cookie from "./components/Cookie";
import Copyright from "./components/Copyright";

function App() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop /> {/* ✅ Always mounted and listens to location changes */}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Mawalog />} />
          <Route path="/new" element={<Pricing />} />
          <Route path="/contact" element={<Sayhello />} />
          <Route path="/about" element={<About />} />
          <Route path="/part" element={<Partner />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/gate" element={<Gate />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/features" element={<Features />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/meetq" element={<MeetQ />} />
          <Route path="/featuresQ" element={<FeaturesQ />} />
          <Route path="/industriesQ" element={<IndustriesQ />} />
          <Route path="/MFaq" element={<MeetFaq />} />
          <Route path="/SAG" element={<SAGate />} />
          <Route path="/price" element={<Price />} />
          <Route path="/priceq" element={<PriceQ />} />
          <Route path="/explore" element={<ExploreProduct />} />
          <Route path="/coming" element={<Coming />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/cookie" element={<Cookie />} />
          <Route path="/copyright" element={<Copyright />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
